import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-order-review',
  templateUrl: './order-review.component.html',
  styleUrls: ['./order-review.component.scss'],
})
export class OrderReviewComponent implements OnInit {
  showModal = true;

  orderData: any;
  displayFields: any[] = [];
  shippingFields: any[] = [];
  billingFields: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OrderReviewComponent>,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.orderData = this.data?.value;

    console.log('Order Data:', this.orderData);
    

    this.displayFields = [
      { label: 'Name', value: this.orderData?.user_name },
      { label: 'Email', value: this.orderData?.user_email },
      { label: 'Order Number', value: this.orderData?.order_number },
      { label: 'Total Amount', value: `$${this.orderData?.total_amount}` },
    ];

    const shipping = this.orderData?.shipping_address || {};
    this.shippingFields = [
      { label: 'Name', value: shipping.name },
      { label: 'Address', value: shipping.address },
      { label: 'City', value: shipping.city },
      { label: 'State', value: shipping.state },
      { label: 'Zip', value: shipping.zip },
      { label: 'Phone', value: shipping.phone },
    ];

    const billing = this.orderData?.billing_address || {};
    this.billingFields = [
      { label: 'Name', value: billing.name },
      { label: 'Address', value: billing.address },
      { label: 'City', value: billing.city },
      { label: 'State', value: billing.state },
      { label: 'Zip', value: billing.zip },
    ];
  }

  closePopup() {
    this.dialogRef.close();
  }
}
